import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import Select from "components/common/Select";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableLog = [
    { label: t("googleworkspacev2.log_types.admin"), value: "ADMIN_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.drive"), value: "DRIVE_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.authorization_token"), value: "AUTHORIZATION_TOKEN_LOGS" },
    { label: t("googleworkspacev2.log_types.calendar"), value: "CALENDAR_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.meet"), value: "MEET_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.device"), value: "DEVICES_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.chat"), value: "CHAT_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.gmail"), value: "GMAIL_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.user_accounts"), value: "USER_ACCOUNTS_LOGS" },
    { label: t("googleworkspacev2.log_types.login"), value: "LOGIN_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.groups"), value: "GROUPS_ACTIVITY_LOGS" },
    { label: t("googleworkspacev2.log_types.classroom"), value: "CLASSROOM_LOGS" },
    { label: t("googleworkspacev2.log_types.chrome"), value: "CHROME_LOGS" },
    { label: t("googleworkspacev2.log_types.saml"), value: "SAML_LOGS" },
    { label: t("googleworkspacev2.log_types.gplus"), value: "GPLUS_ACTIVITY_LOGS" }
  ];
  const [logTypes, setLogTypes] = useState(INITIAL_FORMDATA.availableLogs.value);
  const [logTypeVal, setLogTypeVal] = useState(false);
  const handleSubmit = () => {
    if (logTypes.length === 0) {
      setLogTypeVal(true);
      return;
    }
    formData.contentTypes.value = logTypes;
    onSubmit();
  };
  const handlePageSizeChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  const handleLagOffsetChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      disabled: formError,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "logs" }, t("googleworkspacev2.subscribe.log_types_label")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "contentTypes",
        id: "contentTypes",
        onChange: (selected) => {
          setLogTypes(selected);
        },
        options: availableLog,
        value: logTypes || ""
      }
    ),
    logTypeVal && logTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "logTypes" }, t("googleworkspacev2.subscribe.select_at_least_one")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("googleworkspacev2.subscribe.log_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue,
        min: "1",
        max: "60",
        onChange,
        required: true,
        help: t("googleworkspacev2.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(
      FormAdvancedOptions,
      {
        onChange,
        handlePageSizeChange,
        handleLagOffsetChange
      }
    )
  );
};
export default StepSubscribe;
